import { FC } from 'react'
import styled from 'styled-components'

interface LevelRatingQuestionLabelLayoutMobileProps {
  label: string
}

const LevelRatingQuestionLabelLayoutMobile: FC<
  LevelRatingQuestionLabelLayoutMobileProps
> = ({ label, children }) => {
  return (
    <StyledWrapper>
      <p>{label}</p>
      <div className="information-box">{children}</div>
    </StyledWrapper>
  )
}

export default LevelRatingQuestionLabelLayoutMobile

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  > p {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.64px;
    color: #333;
  }
  > .information-box {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`
